import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { CategoryAva } from '../../pieces/CategoryAva';
import { CategoryTitle } from '../../pieces/CategoryTitle';
import { Author } from '../../pieces/Author';
import { Timestamp } from '../../pieces/Timestamp';
import { ThreadMenu } from '../../pieces/ThreadMenu';

export function Header({
  handleBookmarkButton,
  category,
  ownerId,
  createdAt,
  isBookmarked,
}) {
  return (
    <div className="flex flex-row items-center justify-between">
      <div className="flex h-10 items-center gap-3">
        <CategoryAva category={category} />
        <div className="flex flex-col">
          <div className="text-clip line-clamp-1">
            <CategoryTitle category={category} />
          </div>
          <div className="inline-flex items-center gap-1 text-xs">
            <div className="text-clip line-clamp-1">
              <Author userId={ownerId} />
            </div>
            <div className="opacity-80 group-hover:opacity-90">
              <Icon icon="ci:dot-03-m" />
            </div>
            <div className="text-clip opacity-80 line-clamp-1 group-hover:opacity-90 max-[319px]:hidden">
              <Timestamp createdAt={createdAt} />
            </div>
          </div>
        </div>
      </div>
      <ThreadMenu
        handleBookmarkButton={handleBookmarkButton}
        isBookmarked={isBookmarked}
      />
    </div>
  );
}

Header.propTypes = {
  category: PropTypes.string.isRequired,
  ownerId: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  handleBookmarkButton: PropTypes.func.isRequired,
  isBookmarked: PropTypes.bool,
};
